module.exports = __webpack_public_path__ + "img/conny-f-stage2.3f582ece.png";